var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4803 7.8001C10.4803 6.47462 9.6207 5.4001 8.56031 5.4001H2.80031C1.73992 5.4001 0.880311 6.47462 0.880311 7.8001V15.0001C0.880311 16.3256 1.73992 17.4001 2.80031 17.4001H8.56031C9.6207 17.4001 10.4803 16.3256 10.4803 15.0001V7.8001Z",
    fill: "#4BA5AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4003 0.600098C13.4607 0.600098 14.3203 1.67461 14.3203 3.0001V10.2001C14.3203 11.5256 13.4607 12.6001 12.4003 12.6001C12.4003 12.6001 12.4003 7.50024 12.4003 4.50024C12.4003 3.00024 10.962 3.00022 10.5541 3.00024C7.60024 3.00039 4.72031 3.0001 4.72031 3.0001C4.72031 1.67461 5.57992 0.600098 6.64031 0.600098H12.4003Z",
    fill: "#4BA5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fc86b39a.svg";
export { ForwardRef as ReactComponent };